module.exports = __webpack_public_path__ + "static/img/live.bc88f950.gif";